export const prFeeOptions = {
  PERCENTAGE: "PERCENTAGE",
  FLAT: "FLAT",
};
